module.exports = __webpack_public_path__ + "img/instagram.ddb4bae0.svg";